import React from 'react';
import { Helpers } from '../../../core/src/helpers';
import ImageWithPlaceholder from '../../../shared/components/image-with-placeholder';
import { RadioIcon } from '../../../shared/components/radio';
import ProductPrice from '../../../product/components/product-price';

import '../../css/bundle-item.less';

export default ({bundle, onClick, selected, showProductPrice, productPrice, template, className, openModal}) => {
    const { metadata, bundleIndex } = bundle;
    if(!metadata)return null;
    const { optionName, valuemsg='', icon='', disclaimer } = metadata;
	const productPriceAriaLabel = `$${Number(productPrice.props.children.props.price.salePrice).toFixed(2)}`
	const itemSelected = selected ? ' selected' : ''
    if(!productPrice)productPrice = <ProductPrice product={bundle} />;
    switch(template) {
        case "V1":
            const iconSrc = Helpers.getCDNUrl(icon,'', 75);
            return(
                <button aria-label={`${optionName} ${showProductPrice && productPriceAriaLabel}${itemSelected}`} className={`bundle-item${itemSelected}${className ? ` ${className}` : ''} unstyled`} onClick={()=>onClick(bundleIndex)}>
                    <span className={`checkbox ${itemSelected ? ' checked' : ''}`}></span>
                    <div className='item-image'>
                        <ImageWithPlaceholder className='logo-img' src={iconSrc}/>
                    </div>
                    <div className='item-content'>
                        <p className='content-header'>{optionName}</p>
                        <span className='content-promo'>
                            {valuemsg}
                            {disclaimer && <span className='content-details' onClick={()=>openModal(disclaimer)}>Details</span>}
                        </span>
                    </div>
                    <div className='item-price'>
                        {showProductPrice && productPrice}
                    </div>
                </button>
            );
        default:
            return(
                <button aria-label={`${optionName} ${showProductPrice && productPrice}`} className={`bundle-item${itemSelected}${className ? ` ${className}` : ''} unstyled`} onClick={()=>onClick(bundleIndex)}>
                    <div className='item-radio'>
                        <RadioIcon/>
                    </div>
                    <div className='item-radio-content'>
                        <p className='content-header'>{optionName}</p>
                        <span className='content-promo orange'>
                            {valuemsg}
                            {disclaimer && <span className='content-details' onClick={()=>openModal(disclaimer)}>Details</span>}
                        </span>
                    </div>
                    <div className='item-price'>
                        {showProductPrice && productPrice}
                    </div>
                </button>
            );
    }
}
